import { render, staticRenderFns } from "./VocalContent.vue?vue&type=template&id=691dfd56&"
import script from "./VocalContent.vue?vue&type=script&lang=js&"
export * from "./VocalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports